import React from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

class FeatureList extends React.Component {
   render() {
      const { features } = this.props;
      return (
         <ListGroup>
            {features.map((feature) => (
               <ListGroupItem key={feature.id} >
                  {feature.name}
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}

FeatureList.propTypes = {
   features: React.PropTypes.array
};
export default FeatureList;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/FeatureClass/FeatureList.js
 **/